import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, useNavigate as reactUseNavigate, useLocation } from "react-router-dom";
import { NavigationMenu } from "@shopify/app-bridge-react";
import { useNavigate as shopifyUseNavigate } from "@shopify/app-bridge-react";
import { Navigation } from "@shopify/polaris";
import { HomeMinor, OrdersMinor, ProductsMinor } from "@shopify/polaris-icons";
import { t } from "i18next";
import { getNavigationLinks } from "@/Assets/Mocks/Navigation.mock";
import { ProfileContext } from "@/Context/ProfileContext";
import { localStorage } from "@/Utils/Index";

export const AppNavigationMenu = () => {
  let NavigationLinks = getNavigationLinks();
  const { profileData } = useContext(ProfileContext);
  const location = useLocation();
  const navigation = reactUseNavigate();
  const [selected, setSelected] = useState(location.pathname);

  if (process.env.ENV === "dev") {
    NavigationLinks.splice(2, 0, {
      label: "Backend Testing",
      destination: "/backendTesting",
    });
  }
  if (profileData && profileData?.customPlan) {
    if (process.env.ENV === "dev") {
      NavigationLinks.splice(4, 0, {
        label: t("navigation.Custom Plan"),
        destination: "/customPricing",
      });
    } else {
      NavigationLinks.splice(3, 0, {
        label: t("navigation.Custom Plan"),
        destination: "/customPricing",
      });
    }
  }
  const handleActiveLink = (link, location) => {
    const params = new URLSearchParams(location.href);
    const activenavmenu = params.get("activenavmenu");
    let parentMenu = "";
    if (activenavmenu?.length > 0) {
      parentMenu = `/${activenavmenu}`;
      return link.destination === parentMenu;
    } else {
      return link.destination === location.pathname;
    }
  };

  const handleClick = useCallback((item) => {
    navigation(item.destination);
    setSelected(item.destination);
  }, []);

  if (!localStorage()?.getItem("adminAccessToken")) {
    return (
      <NavigationMenu
        navigationLinks={NavigationLinks}
        matcher={(link, location) => handleActiveLink(link, location)}
      />
    );
  }

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={NavigationLinks.map((item) => ({
          ...item,
          onClick: () => handleClick(item),
          icon: HomeMinor,
          selected: selected === item.destination,
        }))}
      />
    </Navigation>
  );
};

export const navigate = () => {
  let navigate;
  if (!localStorage()?.getItem("adminAccessToken")) {
    navigate = shopifyUseNavigate();
  } else {
    navigate = reactUseNavigate();
  }
  return navigate;
};
